module.exports = __webpack_public_path__ + "img/Group5.68d24e45.svg";